import { render, staticRenderFns } from "./course-content-add.vue?vue&type=template&id=e72d011e&"
import script from "./course-content-add.vue?vue&type=script&lang=js&"
export * from "./course-content-add.vue?vue&type=script&lang=js&"
import style0 from "./course-content-add.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports